import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/parent/')({
  component: ParentToday,
});

function ParentToday() {
  return (
    <div className="space-y-8">
      <header>
        <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
          Welcome
        </p>
        <h1 className="mt-2">Today</h1>
      </header>

      <section aria-labelledby="upcoming-heading" className="surface-elevated p-6">
        <h2 id="upcoming-heading" className="text-[var(--text-xl)]">
          Upcoming classes
        </h2>
        <p className="mt-2 text-[var(--color-ink-muted)]">
          Sprint 2 wires this section to your dancer's real schedule.
        </p>
      </section>

      <section aria-labelledby="notifications-heading" className="surface-elevated p-6">
        <h2 id="notifications-heading" className="text-[var(--text-xl)]">
          Recent
        </h2>
        <p className="mt-2 text-[var(--color-ink-muted)]">
          Messages and announcements from the studio will appear here in Sprint 3.
        </p>
      </section>
    </div>
  );
}
